import React from "react";

const ConsentPage = () => {
    return (
        <main className="privacy-page" style={{ padding: 32, maxWidth: 980, margin: "0 auto", fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial", lineHeight: 1.6, color: "#111", background: "#fff" }}>
            <article>
                <style>{`
                  .privacy-page ul li{margin-bottom:12px;}
                  .privacy-page p,
                  .privacy-page li,
                  .privacy-page h1,
                  .privacy-page h2,
                  .privacy-page h3,
                  .privacy-page h4,
                  .privacy-page address,
                  .privacy-page div {
                    text-align: justify;
                    text-justify: inter-word;
                  }
                `}</style>
                <header>
                    <h1 style={{ fontSize: 28, marginBottom: 12 }}>Согласие на обработку персональных данных</h1>
                </header>

                <section style={{ marginTop: 20 }}>
                    <div>
                        <p>
                            Настоящим я, во исполнение требований Федерального закона от 27.07.2006 г. № 152‑ФЗ «О персональных данных» (с изменениями и дополнениями) свободно, своей волей и своем интересе, а также подтверждая свою дееспособность, даю свое согласие Обществу с ограниченной ответственностью (ИНН 7716952300), место нахождения: 127081, Москва, Ясный проезд, д. 1, 229 (далее – ООО), сайт ООО: https://pro-wellness.ru/ на обработку своих персональных данных со следующими условиям:
                        </p>

                        <ol style={{ marginLeft: 40 }}>
                            <li>
                                Данное Согласие дается на обработку персональных данных с использованием средств автоматизации. Согласие дается на обработку следующих моих персональных данных: пользовательские данные (сведения о местоположении, тип и версия ОС, тип и версия Браузера, тип устройства и разрешение его экрана; источник, откуда пришел на сайт пользователь; с какого сайта или по какой рекламе; язык ОС и Браузера; какие страницы открывает и на какие кнопки нажимает пользователь; дата и время сессии, IP-адрес), а также иная общедоступная информация обо мне.
                            </li>
                            <li>Персональные данные не являются общедоступными.</li>
                            <li>Цель обработки персональных данных: аналитика действий физического лица на веб‑сайте, оценка эффективности рекламных и маркетинговых кампаний и функционирования веб‑сайта.</li>
                            <li>Основанием для обработки персональных данных является статья 24 Конституции Российской Федерации; статья 6 Федерального закона № 152‑ФЗ «О персональных данных»; настоящее Согласие посетителя сайта на обработку персональных данных.</li>
                            <li>В ходе обработки с персональными данными будут совершены следующие действия: сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, блокирование, удаление, уничтожение.</li>
                            <li>Настоящим я уведомлен ООО, что предполагаемыми пользователями персональных данных являются работники ООО, а также лица, привлеченные ООО на условиях гражданско‑правового договора.</li>
                        </ol>

                        <ul style={{marginTop:20}}>
                            <li>7. Я ознакомлен(а), что:</li>
                            <li>
                                7.1. настоящее Согласие на обработку моих персональных данных является бессрочным и может быть отозвано посредством  направления мною в адрес ООО:  127081, Москва, Ясный проезд, д.1, 229, письменного заявления. Датой отзыва считается день, следующий за днем вручения ООО письменного заявления об отзыве Согласия пользователя сайта на обработку персональных данных;
                            </li>
                            <li>
                                7.2. имею право на доступ к моим персональным данным, требовать уточнения (обновление, изменение) моих персональных данных, а также удаления и уничтожения моих персональных данных в случае их обработки ООО, нарушающих мои законные права и интересы, законодательство Российской Федерации.
                            </li>
                            <li>
                                7.3. в случае отзыва Согласия на обработку персональных данных ООО вправе продолжить обработку персональных данных без моего согласия при наличии оснований, указанных в пунктах 2.11 части 1 статьи 6, части 2 статьи 10 и части 2 статьи 11 Федерального закона №152‑ФЗ «О персональных данных» от 27.07.2006 г.
                            </li>
                        </ul>

                        <ul>
                            <li>8. Настоящим Согласием я подтверждаю, что являюсь субъектом предоставляемых персональных данных, а также подтверждаю достоверность предоставляемых данных.</li>

                            <p>9. Настоящее Согласие действует все время до момента прекращения обработки персональных данных, согласно п. 7.1 Согласия.</p>
                        </ul>

                        <address style={{ marginTop: 16, fontStyle: "normal" }}>
                            ООО ПРО ВЕЛНЕС<br />
                            ИНН 7716952300<br />
                            127081, Москва, Ясный проезд, д. 1, 229 <br />
                            +7 925 180 0099
                        </address>

                    </div>
                </section>
            </article>
        </main>
    );
};

export { default as routeMain } from "./routes";
export default ConsentPage;
